import { render, staticRenderFns } from "./addBrowsenew.vue?vue&type=template&id=3a295b27&scoped=true&"
import script from "./addBrowsenew.vue?vue&type=script&lang=js&"
export * from "./addBrowsenew.vue?vue&type=script&lang=js&"
import style0 from "./addBrowsenew.vue?vue&type=style&index=0&id=3a295b27&lang=less&scoped=true&"
import style1 from "./addBrowsenew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a295b27",
  null
  
)

export default component.exports